import React from 'react';

import type {ConfigV2} from '../../util/runfeed';
import {RunsAutoCols} from './RunsAutoCols';
import {RunsDownloadMenu} from './RunsDownloadMenu';
import {useRunSelectorFeatureEnabled} from './RunSelectorFeaturesContext';
import type {RunSelectorRunsPartialVars} from './types';
import {type WBTableColumn} from './WBTable/types';

type RunsSelectorExtraTableActionsRightProps = {
  columns: WBTableColumn[];
  currentPage: number;
  setTableSettings: (settings: any) => void;
  tableSettings: ConfigV2;
  topLevelQueryVariables: RunSelectorRunsPartialVars;
};

export function RunSelectorExtraTableActionsRight(
  props: RunsSelectorExtraTableActionsRightProps
) {
  const isEnabled = useRunSelectorFeatureEnabled();
  return (
    <>
      {isEnabled('export') && (
        <RunsDownloadMenu
          pageQuery={props.topLevelQueryVariables}
          tableSettings={props.tableSettings}
        />
      )}
      {isEnabled('auto-cols') && (
        <RunsAutoCols
          query={props.topLevelQueryVariables}
          tableSettings={props.tableSettings}
          setTableSettings={props.setTableSettings}
          currentPage={props.currentPage}
          columns={props.columns}
        />
      )}
    </>
  );
}
